import { FC } from "react";
import { ICellRendererParams } from "ag-grid-community";
import Stack from "@mui/material/Stack";
import { SnowflakeConnection } from "@/services/cloudchipr.api";
import { UserActivityCell } from "@/components/common/data-grid-cells/UserActivityCell";

export const SnowflakeConnectionConnectedByCellRenderer: FC<
  ICellRendererParams<SnowflakeConnection>
> = ({ data }) => {
  if (!data) {
    return;
  }

  const details = data?.created_by;
  const date = data?.created_at;

  return (
    <Stack height="100%" justifyContent="center">
      <UserActivityCell
        date={date ?? undefined}
        name={details?.name ?? details?.email ?? ""}
        deleted={details?.status === "deleted"}
        profile={details?.profile}
      />
    </Stack>
  );
};
